import { Box, Skeleton, TableCell, TableRow } from "@mui/material";
import React from "react";
import styles from "../style.module.scss";

function SkeletonLoader(props: any) {
  const { rectangularLoader, actionLoader } = props;
  return (
    <React.Fragment>
      {Array.from({ length: 8 }).map((_, index) => (
        <TableRow key={index} className={styles.tableRow}>
          <TableCell sx={{ display: "flex" }}>
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton
              variant="rectangular"
              width={120}
              height={25}
              sx={{ marginLeft: "10px", marginTop: "5px" }}
            />
          </TableCell>
          {Array.from({ length: rectangularLoader }).map((loader) => {
            return (
              <TableCell>
                <Skeleton variant="rectangular" width={120} height={25} />
              </TableCell>
            );
          })}
          {/* <TableCell>
            <Skeleton variant="rectangular" width={120} height={25} />
          </TableCell>
          <TableCell>
            <Skeleton variant="rectangular" width={120} height={25} />
          </TableCell>
          <TableCell>
            <Skeleton variant="rectangular" width={120} height={25} />
          </TableCell> */}

          <TableCell>
            <Box display={"flex"}>
              {Array.from({ length: actionLoader }).map((loader) => {
                return (
                  <Skeleton
                    width={30}
                    height={40}
                    sx={{ marginRight: "10px" }}
                  />
                );
              })}
              {/*             
              <Skeleton width={30} height={40} sx={{ marginRight: "10px" }} />
              <Skeleton width={30} height={40} sx={{ marginRight: "10px" }} /> */}
            </Box>
          </TableCell>
        </TableRow>
      ))}
    </React.Fragment>
  );
}

export default SkeletonLoader;
